import React from "react"
import { type ChakraProps, Heading, useColorMode } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"

interface Heading3WhiteUnderlinedInterface {
  text: string
  props?: ChakraProps
}
export const Heading3WhiteUnderlined = ({ text, props }: Heading3WhiteUnderlinedInterface): JSX.Element => {
  const { colorMode } = useColorMode()

  return (
    <Heading
      color={colorMode === "light" ? "#231F20" : "#ffffff"}
      variant={"RHeading3PT"}
      borderBottomWidth="2px"
      borderBottomColor={Colors.Primary.accent}
      textAlign={"center"}
      p="10px"
      m="0px"
      mx="auto"
      pb={["10px", "10px", "8px"]}
      maxW={["280px", "280px", "100%"]}
      display={"inline-block"}
      {...props}
    >
      {text}
    </Heading>
  )
}
